import { render } from "./ResultsTable.vue?vue&type=template&id=2993abd7&scoped=true"
import script from "./ResultsTable.vue?vue&type=script&lang=js"
export * from "./ResultsTable.vue?vue&type=script&lang=js"

import "./ResultsTable.vue?vue&type=style&index=0&id=2993abd7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2993abd7"]])

export default __exports__